import { get, isEmpty, isNull } from "lodash";
import React, { useEffect, useState, useContext } from "react";
import {
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
  Image,
  Button,
} from "react-bootstrap";
import {
  AddToolTip,
  ErrorsPieChart,
  FileTypeWithExt,
  GetInitials,
  WarningModal,
} from "../../../components";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { PayrollCardTop } from "../../../components";
import ExcelImage from "../../../styles/plan.png";
import { ProgressFileStatus } from "../../../components";
import FileSaver from "file-saver";
import { getDownloadInputFileReport, getCompanyLogo } from "../../../services";
import {
  FILE_UPLOAD_STATUS,
  MANAGE_PAYROLL_ROUTES,
  OPTIONS_DATA_MAPPER,
  ROUTES,
  usCurrency,
  usDateFormat,
} from "../../../utils";
import upload from "../../../styles/upload.png";
import sftp from "../../../styles/ftp.png";
import create from "../../../styles/create.png";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationCircle,
  faExclamationTriangle,
  faRedo,
} from "@fortawesome/pro-solid-svg-icons";
import { isNullOrUndefined } from "@microsoft/applicationinsights-core-js";
import { useDeepEffect, useRouterParams } from "../../../abstracts";
import { appLayoutStore } from "../../../contexts";
import { deleteUploadedFileById } from "../../../services";
import permissions from "../../../mocks/menuPermissions.json";
import authService from "../../../components/api-authorization/AuthorizeService";

const FileInformation = (props) => {
  const { state: state2 } = useContext(appLayoutStore);
  const [showmodal, setShowmodal] = useState(false);
  const history = useHistory();
  const [roleName, setRoleName] = useState("VOU");
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  const { payrollId } = useRouterParams();
  const handleConfirmClick = () => {
    deleteUploadedFileById(parseInt(payrollId))
      .then((response) => {
        history.push({
          pathname: MANAGE_PAYROLL_ROUTES.NEW_PAYROLL_UPLOAD,
        });
        // dispatch(
        //   setManagePayrollToastInfo({
        //     showToast: false,
        //     toastMessage: "File Deleted Successfully",
        //   })
        // )
        return response;
      })
      .catch((error) => {
        throw error;
      });
  };
  const handleCancelClick = () => {
    setShowmodal(false);
  };

  const downloadFile = (id, filename) => {
    var extension =
      filename?.split(".")[filename?.split(".").length - 1] == "csv"
        ? "csv"
        : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

    getDownloadInputFileReport(id).then((response) => {
      var blob = new Blob([response], {
        type: extension,
      });
      FileSaver.saveAs(blob, filename);
    });
  };
  const {
    payrollDetails,
    errorType,
    setKeyValue,
    selectedTabIndex,
    setTabIndex,
  } = props;
  const onWarningClick = () => {
    //history.push(`${ROUTES.PAYROLL_FILE_STATUS}/${payrollId}/?tab=2`);
    setKeyValue(2);
    setTabIndex("warning");
  };
  const onErrorClick = () => {
    //history.push(`${ROUTES.PAYROLL_FILE_STATUS}/${payrollId}/?tab=2`);
    setKeyValue(2);
    setTabIndex("errors");
  };
  const getColor = () => {
    switch (payrollDetails?.fileStatus) {
      case FILE_UPLOAD_STATUS.CreationInProgress:
        return "#067492";
      case FILE_UPLOAD_STATUS.FileUploadInProgress:
        return "#067492";
      case FILE_UPLOAD_STATUS.ErrorCorrectionRequired:
        return "#c4061a";
      case FILE_UPLOAD_STATUS.PendingSubmission:
        return "#a05a06";
      case FILE_UPLOAD_STATUS.PayrollFundingInProgress:
        return "#a05a06";
      case FILE_UPLOAD_STATUS.AwaitingFunding:
        return "#a05a06";
      case FILE_UPLOAD_STATUS.AwaitingTrade:
        return "#a05a06";
      case FILE_UPLOAD_STATUS.Completed:
        return "#06741a";
      case FILE_UPLOAD_STATUS.Cancelled:
        return "#8e8e93";
      case FILE_UPLOAD_STATUS.Deleted:
        return "#8e8e93";
      case FILE_UPLOAD_STATUS.SystemFailure:
        return "#c4061a";
      case FILE_UPLOAD_STATUS.AwaitingFundConfirmation:
        return "#a05a06";
      case FILE_UPLOAD_STATUS.PayrollFunded:
        return "#06741a";
      case FILE_UPLOAD_STATUS.FundingFailed:
        return "#c4061a";
      default:
        return "#c4061a";
    }
  };
  const [companyImage, setCompanyImage] = useState([]);

  useDeepEffect(() => {
    getCompanyLogo(payrollDetails?.companyId).then((response) => {
      setCompanyImage(response);
    });
  }, []);

  return (
    <>
      {/* <div className="d-flex flex-col">
            <Image src={ExcelImage} width="100px" height="100px" />
            <p className="mt-2 mr-4">{payrollDetails.companyName}</p>
          </div> */}
      {/* <FileTypeWithExt
            fileName={payrollDetails.fileName}
            uploadedThrough={payrollDetails.uploadedThrough}
            uploadedBy={payrollDetails.uploadedBy}
            uploadedDate={payrollDetails.uploadedDate}
          /> */}
      <div
        className="my-3 p-3"
        style={{ border: "2px solid #d8d8dc", borderRadius: "8px" }}
      >
        <div className="d-flex justify-content-space-around mb-4">
          <div className="mr-3" style={{ width: "70%" }}>
            <div className="word-wrap-name excel-text ft-14 m-0">
              <AddToolTip
                className="ft-14 font-weight-500 company-name"
                name={payrollDetails.fileName}
              >
                <p className="ft-14 black-text font-weight-500 mt-10 d-flex">
                  <div
                    style={{
                      width: "46px",
                      height: "46px",
                      marginRight: "10px",
                      backgroundColor: "#D9D9D9",
                      borderRadius: "30px",
                    }}
                  >
                    <Image
                      src={
                        payrollDetails.uploadedThrough == "FileUpload"
                          ? upload
                          : payrollDetails.uploadedThrough == "CreatePayroll"
                          ? create
                          : sftp
                      }
                      style={{ marginLeft: "12px", marginTop: "14px" }}
                    />{" "}
                  </div>
                  <span className="d-flex flex-col">
                    <span className="d-flex">
                      {(payrollDetails.fileName?.split(".")[0] || "")?.slice(
                        0,
                        30
                      )}
                      ... &nbsp;
                      <p className="grey-text">
                        {(payrollDetails.fileName || "")?.slice(
                          payrollDetails?.fileName?.indexOf("."),
                          payrollDetails?.fileName?.length
                        )}
                      </p>
                    </span>
                    <span style={{ marginTop: "-10px" }} className="ft-12">
                      Uploaded by:{" "}
                      <span className="grey-text">
                        {payrollDetails?.uploadedBy}{" "}
                        {moment(new Date(payrollDetails?.uploadedDate)).format(
                          "MM/DD/YYYY hh:mm A"
                        )}
                      </span>
                    </span>
                  </span>
                </p>
              </AddToolTip>
            </div>
            <div className="d-flex flex-col pr-5 ml-2 mt-3">
              <span className="ft-14">Description</span>
              <span className="ft-12 grey-text">
                {payrollDetails.description}
              </span>
              <div className="d-flex mt-3 gap-3">
                <p className="d-flex flex-col">
                  <span className="ft-12 grey-text">Profile Name</span>
                  <span className="ft-14 fw-600">
                    {payrollDetails.profileName}
                  </span>
                </p>
                <span className="vertical-line" />
                <p className="d-flex flex-col">
                  <span className="ft-12 grey-text">Total Records</span>
                  <span className="ft-14 fw-600">
                    {payrollDetails.totalRecords}
                  </span>
                </p>
                <span className="vertical-line" />
                <p className="d-flex flex-col">
                  <span className="ft-12 grey-text">Total Hours</span>
                  <span className="ft-14">
                    {payrollDetails.totalHours?.toFixed(2)}
                  </span>
                </p>
                {payrollDetails.fileType !== 1 && (
                  <>
                    <span className="vertical-line" />
                    <p className="d-flex flex-col">
                      <span className="ft-12 grey-text">Total Amount</span>
                      <span className="ft-14 fw-600">
                        {usCurrency(payrollDetails.totalAmount)}
                      </span>
                    </p>
                  </>
                )}
              </div>
              <p
                className="ft-12 link-text-mapper mt-2 cursor-pointer primary-color"
                onClick={() => {
                  downloadFile(payrollDetails.id, payrollDetails.fileName);
                }}
              >
                <i class="far fa-download" aria-hidden="true"></i> Download File
              </p>
            </div>
          </div>

          <div
            // className="m-3 p-3 d-flex flex-col"
            style={{
              width: "30%",
              backgroundColor: "#F6F6F6",
              borderRadius: "8px",
            }}
          >
            <div className="m-3 p-3 d-flex flex-col">
              <span className="ft-14 grey-text">File status</span>
              <span className="ft-16 fw-600" style={{ color: getColor() }}>
                {payrollDetails.fileStatus ===
                FILE_UPLOAD_STATUS.FileUploadInProgress ? (
                  <span className="inprogress-text">
                    File upload in progress
                  </span>
                ) : payrollDetails.fileStatus ===
                  FILE_UPLOAD_STATUS.ErrorCorrectionRequired ? (
                  <span className="error-text">Error corrections required</span>
                ) : payrollDetails.fileStatus ===
                  FILE_UPLOAD_STATUS.StructuralValidationFailed ? (
                  <span className="error-text">Error in file processor</span>
                ) : payrollDetails.fileStatus ===
                  FILE_UPLOAD_STATUS.SystemFailure ? (
                  <span className="error-text mt-1">System failure</span>
                ) : payrollDetails.fileStatus ===
                  FILE_UPLOAD_STATUS.PendingSubmission ? (
                  <span className="pending-text">Pending submission</span>
                ) : payrollDetails.fileStatus ===
                  FILE_UPLOAD_STATUS.AwaitingFunding ? (
                  <span className="awaiting-fund-text">Awaiting funding</span>
                ) : payrollDetails.fileStatus ===
                  FILE_UPLOAD_STATUS.CreationInProgress ? (
                  <span className="creation-text">Creation in progress</span>
                ) : payrollDetails.fileStatus ===
                  FILE_UPLOAD_STATUS.Cancelled ? (
                  <span className="cancelled-text">Cancelled</span>
                ) : payrollDetails.fileStatus === FILE_UPLOAD_STATUS.Deleted ? (
                  <span className="deleted-text">Deleted</span>
                ) : payrollDetails.fileStatus ===
                  FILE_UPLOAD_STATUS.AwaitingTrade ? (
                  <span className="awaiting-trade-text">Awaiting trade</span>
                ) : payrollDetails.fileStatus ===
                  FILE_UPLOAD_STATUS.AwaitingFundConfirmation ? (
                  <span className="awaiting-fund-confirm-text">
                    Awaiting fund confirmation
                  </span>
                ) : payrollDetails.fileStatus ===
                  FILE_UPLOAD_STATUS.PayrollFunded ? (
                  <span className="payroll-funded-text">Payroll funded</span>
                ) : payrollDetails.fileStatus ===
                  FILE_UPLOAD_STATUS.Completed ? (
                  <span className="completed-text">Completed</span>
                ) : payrollDetails.fileStatus ===
                  FILE_UPLOAD_STATUS.PayrollFundingInProgress ? (
                  <span className="completed-text">
                    Final submit in progress
                  </span>
                ) : null}
              </span>
              <hr className="w-100" />
              <p
                className="pl-3 pt-2 pb-2 cursor-pointer"
                style={{
                  backgroundColor: "#ffffff",
                  borderRadius: "8px",
                  boxShadow: "-4px 0px 4px rgba(0, 0, 0, 0.1)",
                }}
                onClick={() => onWarningClick()}
              >
                <FontAwesomeIcon
                  icon={faExclamationCircle}
                  style={{ color: "#A05A06" }}
                />
                <span className="ml-2 ft-16 fw-600">
                  {payrollDetails.totalWarnings} Warnings
                </span>
              </p>
              <p
                className="pl-3 pt-2 pb-2 cursor-pointer"
                style={{
                  backgroundColor: "#ffffff",
                  borderRadius: "8px",
                  boxShadow: "-4px 0px 4px rgba(0, 0, 0, 0.1)",
                }}
                onClick={() => onErrorClick()}
              >
                <FontAwesomeIcon
                  icon={faExclamationTriangle}
                  style={{ color: "#D0273D" }}
                />
                <span className="ml-2 ft-16 fw-600">
                  {payrollDetails.totalErrors} Errors
                </span>
              </p>
            </div>
            {permissions &&
              permissions[roleName]["payrollSubMenu"]?.[
                "reUploadFile"
              ]?.includes("C") && (
                <div
                  className="d-flex flex-direction-column justify-content-center"
                  style={{
                    backgroundColor: "#F6F6F6",
                    borderRadius: "8px",
                    height: "40px",
                    backgroundColor: "#E6EDFA",
                    paddingTop: "9px",
                  }}
                >
                  <FontAwesomeIcon
                    icon={faRedo}
                    className="mr-top2 primary-color"
                    style={{ marginRight: "8px" }}
                  />
                  <Link
                    onClick={() => {
                      setShowmodal(true);
                    }}
                  >
                    Reupload
                  </Link>
                </div>
              )}
          </div>
        </div>

        <div>Plan Details</div>
        <div className="d-flex py-3 ml-3 mr-3">
          <span className="ft-12 grey-text w-25">Company name</span>
          <span className="ft-12 grey-text w-25">Plan details</span>
          <span className="ft-12 grey-text w-20">Plan groups</span>
          <span className="ft-12 grey-text w-20">Payroll frequency</span>
          <span className="ft-12 grey-text w-10">Pay date</span>
        </div>
        {payrollDetails?.fileInformationPlanDetails?.map((PlanDetails) => {
          return (
            <div
              className="d-flex p-3 mb-3"
              style={{
                border: "1px solid #d8d8dc",
                boxShadow: "-4px 0px 4px rgba(0, 0, 0, 0.1)",
                borderRadius: "8px",
              }}
            >
              <span className="d-flex ft-14 w-25">
                {!isEmpty(companyImage) ? (
                  <Image src={companyImage} className="w-50" />
                ) : (
                  <GetInitials
                    name={PlanDetails.companyName}
                    className="w-50"
                  />
                )}
                <p className="ml-2 mr-2 mt-2 w-30">
                  <AddToolTip name={PlanDetails.companyName} />
                </p>
              </span>
              <span className="ft-14 mt-2 w-25">
                {PlanDetails.planId}
                <br></br>
                <AddToolTip name={PlanDetails.planName} />
              </span>
              <span className="ft-14 mt-2 w-20">
                <AddToolTip name={payrollDetails.planGroupNames} />
              </span>
              <span className="ft-14 mt-2 w-20">
                <AddToolTip name={payrollDetails.payrollFrequencyName} />
              </span>
              <span className="ft-14 mt-2 w-10">
                {usDateFormat(payrollDetails.payDate)}
              </span>
            </div>
          );
        })}
      </div>

      {/* <div className="border-vertical-line p-4" style={{ marginTop: "-30px" }}>
        <ProgressFileStatus
          stepperDetails={payrollDetails.progress}
          status={payrollDetails.fileStatus}
          fileStatus={payrollDetails.fileStatus}
          errorType={errorType}
          warnings={get(payrollDetails, "totalWarnings", 0)}
          errors={get(payrollDetails, "totalErrors", 0)}
          validationReports={get(payrollDetails, "validationReports", [])}
          duplicatesCount={get(payrollDetails, "duplicateRecords", [])}
          showTrash={false}
          menu="payroll"
        />
        <hr className="w-100" />
        <p className="ft-16 fw-500">{payrollDetails.totalRecords}</p>
        <p className="ft-14">Total Records</p>
      </div> */}
      <WarningModal show={showmodal} onHide={handleCancelClick}>
        <div className="remove-text">
          <h4>Are you sure?</h4>
          <p>
            You are attempting to reupload the file. This file will be deleted
            and you will be navigated to the payroll upload page. Do you wish to
            continue?
          </p>
          <Button className="remove-btn mr-4" onClick={handleConfirmClick}>
            Yes
          </Button>
          <Button className="cancel-btn" onClick={handleCancelClick}>
            No
          </Button>
        </div>
      </WarningModal>
    </>
  );
};

export default FileInformation;
